module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gg-box"
  }, [_c('div', {
    staticClass: "gg-box-container"
  }, [_c('div', {
    staticClass: "gg-box-top"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('all.gonggao')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/image/tanchuang_x_b@2x.png"),
      "alt": "关闭"
    },
    on: {
      "click": _vm.handleClose
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gg-box-content"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.noticeText),
      expression: "noticeText"
    }],
    attrs: {
      "placeholder": _vm.$t('all.qingshuru')
    },
    domProps: {
      "value": (_vm.noticeText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.noticeText = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gg-box-btn"
  }, [_c('div', {
    staticClass: "gg-box-btn-btn",
    on: {
      "click": _vm.updNotice
    }
  }, [_vm._v(_vm._s(_vm.$t('all.tijiao')))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ccbbbb2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/gongao/gonggao.vue
// module id = 1011
// module chunks = 1